import React from "react";
import "@/styles/components/button.scss";
import { Button, Flex } from "antd";
const ButtonComponent = ({
  varient = "",
  label = "",
  size = "large",
  className = "",
  iconRight = true,
  disabled = false,
  htmlType = "button",
  children,
  onClick,
  ...rest
}) => {
  return (
    <Button
      type={varient}
      htmlType={htmlType}
      disabled={disabled}
      className={`btn ${className} ${disabled ? "cursor-notAllowed" : ""}`}
      size={size}
      onClick={
        !disabled
          ? onClick
          : () => {
              console.log("Knock Knock");
            }
      }
      style={{
        opacity: disabled ? 0.5 : 1,
      }}
      {...rest}
    >
      <Flex gap={"5px"} className="btn-content">
        {label}
        {children}
      </Flex>
      {/* {iconRight && (
        <Fragment>
          {label}&nbsp;&nbsp;{children}
        </Fragment>
      )}
      {!iconRight && (
        <Fragment>
          {children}&nbsp;&nbsp;{label}
        </Fragment>
      )} */}
    </Button>
  );
};

export default ButtonComponent;
